<template>
  <modal :visible.sync="isShowDialog" :title="detailInfo.name"  width="500px"
    append-to-body  @close="close">
    <div class="rule-div" v-if="detailInfo.rule && Object.keys(detailInfo.rule).length">
      <!-- 大规则 -->
      <div v-for="(item, key) in detailInfo.rule" :key="key" class="border mb-10">
        <div class="uk-flex uk-flex-between uk-flex-middle bd-b pd-10">
          <span>{{ $t(ruleTypesConvert(key).title)}}</span>
        </div>
        <!-- 大规则里面的规则list -->
        <div class="pd-10">
          <div v-for="(item2, index2) in item" :key="index2">
          <el-divider content-position="left" v-if="item2.logic !== 0">
              <el-tag :type="item2.logic === 1 ? 'info': ''"
                class="cursor-pointer"
              >And</el-tag>
              <el-tag :type="item2.logic === 2 ? 'info': ''"
                class="ml-5 cursor-pointer"
              >Or</el-tag>
            </el-divider>
            <!-- 是group时 -->
            <div v-if="item2.isGroup" class="border mb-10">
              <div class="uk-flex uk-flex-between uk-flex-middle bd-b pd-10">
                <span>{{ item2.name }}</span>
              </div>
              <div class="pd-10" v-for="(glist,gindex) in item2.ruleList" :key="gindex">
                <el-divider content-position="left" v-if="glist.logic !== 0">
                  <el-tag :type="glist.logic === 1 ? 'info': ''"
                    class="cursor-pointer"
                  >And</el-tag>
                  <el-tag :type="glist.logic === 2 ? 'info': ''"
                  class="ml-5 cursor-pointer"
                  >Or</el-tag>
                </el-divider>
                <div class="uk-flex  uk-flex-middle border">
                  <el-select v-model="glist.type" style="width: 120px;" class="bd-r pd-10" disabled>
                      <el-option v-for="(item, key2) in ruleItemType(key)" :key="key2" :label="item.title"
                          :value="parseInt(key2)"></el-option>
                  </el-select>
                  <div class="uk-flex-1 ml-5 pl-5">
                    <!-- 数值容错 -->
                    <template v-if="glist.type === 1">
                      上限 + 
                      <el-input v-model="glist.max" placeholder="" style="width: 70px;"
                        disabled>
                      </el-input>
                      下限 -
                      <el-input v-model="glist.min" placeholder="" style="width: 70px;"
                        disabled>
                      </el-input>
                    </template>
                    <!-- 时间容错 -->
                    <template v-if="glist.type === 2">
                      容错时长少于
                      <el-input v-model.number="glist.num" placeholder="" style="width: 70px;"
                        disabled></el-input>
                      分
                    </template>
                    <!-- 连续性异常 -->
                    <template v-if="glist.type === 3">
                      连续异常少于
                      <el-input v-model.number="glist.num" placeholder="" style="width: 70px;"
                         disabled></el-input>
                      次
                    </template>
                    <!-- 异常频率 -->
                    <template v-if="glist.type === 4">
                      异常频率少于
                      <el-input v-model.number="glist.num" placeholder="" style="width: 70px;"
                        disabled></el-input>
                      次
                    </template>
                    <!-- 重连时长 -->
                    <template v-if="glist.type === 5">
                      重连时长少于
                      <el-input v-model.number="glist.num" placeholder="" style="width: 70px;"
                        disabled></el-input>
                      分
                    </template>
                    <!-- 断电时长 -->
                    <template v-if="glist.type === 6">
                      断电时长少于
                      <el-input v-model.number="glist.num"  placeholder="" style="width: 70px;"
                         disabled></el-input>
                      分
                    </template>
                    
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="mb-10">
              <div class="uk-flex  uk-flex-middle border">
                <el-select v-model="item2.type" style="width: 120px;" class="bd-r pd-10" disabled>
                    <el-option v-for="(item, key2) in ruleItemType(key)" :key="key2" :label="item.title"
                        :value="parseInt(key2)"></el-option>
                </el-select>
                <div class="uk-flex-1 ml-5 pl-5">
                  <!-- 数值容错 -->
                  <template v-if="item2.type === 1">
                    上限 + 
                    <el-input v-model="item2.max" placeholder="" style="width: 70px;"
                      disabled
                        >
                      </el-input>
                    下限 -
                    <el-input v-model="item2.min" placeholder="" style="width: 70px;"
                      disabled>
                    </el-input>
                  </template>
                  <!-- 时间容错 -->
                  <template v-if="item2.type === 2">
                    容错时长少于
                    <el-input v-model.number="item2.num" placeholder="" style="width: 70px;"
                      disabled></el-input>
                    分
                  </template>
                  <!-- 连续性异常 -->
                  <template v-if="item2.type === 3">
                    连续异常少于
                    <el-input v-model.number="item2.num" placeholder="" style="width: 70px;"
                      disabled></el-input>
                    次
                  </template>
                  <!-- 异常频率 -->
                  <template v-if="item2.type === 4">
                    异常频率少于
                    <el-input v-model.number="item2.num" placeholder="" style="width: 70px;"
                      disabled></el-input>
                    次
                  </template>
                  <!-- 重连时长 -->
                  <template v-if="item2.type === 5">
                    重连时长少于
                    <el-input v-model.number="item2.num" placeholder="" style="width: 70px;"
                      disabled></el-input>
                    分
                  </template>
                  <!-- 断电时长 -->
                  <template v-if="item2.type === 6">
                    断电时长少于
                    <el-input v-model.number="item2.num"  placeholder="" style="width: 70px;"
                      disabled></el-input>
                    分
                  </template>
                  
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <el-empty v-else :description="$t('public.no_data')"></el-empty>
  </modal>
</template>
<script>
import {ruleTypes, ruleTypesConvert, ruleItemType} from '@/utils/convert.js'


export default {
  name: 'RuleDetailDialog',
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    detailInfo: {
      type: Object,
      default: null
    },
  },
  data(){
    return {
      ruleTypes,
      ruleTypesConvert,
      ruleItemType,
    }
  },
  computed: {
    isShowDialog: {
      get: function () {
        return this.isShow
      },
      set: function (val) {
        this.$emit('update:isShow', val) // 可以优化成model  或者minx
      }
    },
  },
  methods: {
    close(){
      this.isShowDialog = false
      this.$emit('close')
    },
  }
}
</script>